import React from 'react';
import {
  components as DefaultSelectComponents,
  ValueContainerProps,
} from 'react-select';
import classNames from 'classnames';
import _get from 'lodash/get';
import { getLangFlagCode } from '@lib/utils/lang';
import styles from '../Select.module.scss';
import CountryOption from './CountryOption';
import LangOption from './LangOption';

function ValueContainer(props: ValueContainerProps): React.ReactElement {
  const { children, ...valueContainerProps } = props;
  const { isMulti, selectProps } = valueContainerProps;
  const OptionComponent = _get(props, 'selectProps.components.Option');

  if (isMulti && Array.isArray(children) && children.length) {
    return (
      // @ts-ignore
      <DefaultSelectComponents.ValueContainer
        {...valueContainerProps}
        className={styles.valueContainer}
      >
        <span className={styles.multiValueWrap}>
          {Array.isArray(children[0]) && children[0].length && (
            <>
              {children[0]}
              {children[0].length > 1 && (
                <span className={styles.valuesCount}>
                  +{children[0].length - 1}
                </span>
              )}
            </>
          )}
          <span>{children[1]}</span>
        </span>
      </DefaultSelectComponents.ValueContainer>
    );
  }

  if (OptionComponent?.name === CountryOption?.name) {
    const value = _get(selectProps, 'value.value', '') as string;
    return (
      // @ts-ignore
      <DefaultSelectComponents.ValueContainer
        {...valueContainerProps}
        className={value ? styles.valueCountryContainer : styles.valueContainer}
      >
        {value && (
          <span
            className={classNames(styles.flag, styles[value.toLowerCase()])}
          />
        )}
        {children}
      </DefaultSelectComponents.ValueContainer>
    );
  }

  if (OptionComponent?.name === LangOption?.name) {
    const value = _get(selectProps, 'value.value', '');
    return (
      // @ts-ignore
      <DefaultSelectComponents.ValueContainer
        {...valueContainerProps}
        className={value ? styles.valueCountryContainer : styles.valueContainer}
      >
        {value && (
          <span
            className={classNames(styles.flag, styles[getLangFlagCode(value)])}
          />
        )}
        {children}
      </DefaultSelectComponents.ValueContainer>
    );
  }

  return (
    // @ts-ignore
    <DefaultSelectComponents.ValueContainer
      {...valueContainerProps}
      className={styles.valueContainer}
    >
      {children}
    </DefaultSelectComponents.ValueContainer>
  );
}

export default ValueContainer;
